
import { useState, useEffect } from 'react';

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

export default function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const targetDate = new Date('2026-06-20T00:00:00').getTime();

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const difference = targetDate - now;

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        setTimeLeft({ days, hours, minutes, seconds });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const timeUnits = [
    { label: 'Gün', value: timeLeft.days },
    { label: 'Saat', value: timeLeft.hours },
    { label: 'Dakika', value: timeLeft.minutes },
    { label: 'Saniye', value: timeLeft.seconds }
  ];

  return (
    <div className="bg-gradient-to-r from-slate-800 to-slate-900 rounded-2xl p-8 text-center">
      <h2 className="text-2xl md:text-3xl font-bold text-white mb-2">
        Sınava Kalan Süre
      </h2>
      <p className="text-gray-300 mb-8">20 Haziran 2026</p>
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {timeUnits.map((unit, index) => (
          <div key={index} className="bg-white/10 backdrop-blur-sm rounded-xl p-4">
            <div className="text-3xl md:text-4xl font-bold text-yellow-400 mb-2">
              {unit.value.toString().padStart(2, '0')}
            </div>
            <div className="text-sm text-gray-300 font-medium">
              {unit.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
